import { Controller, FieldValues, useFormState } from 'react-hook-form';
import ProductSelector from '../selectors/ProductSelector';
import { BaseFormFieldProps } from './types';

export interface FormProductSelectorProps<TFieldValues extends FieldValues = FieldValues>
  extends BaseFormFieldProps<TFieldValues> {
  showAllOption?: boolean;
  showEmptyOption?: boolean;
}

const FormProductSelector = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  isRequired = false,
  showErrorOnTouched = true,
  showAllOption = false,
  showEmptyOption,
  ...rest
}: FormProductSelectorProps<TFieldValues>) => {
  const { touchedFields, errors, isSubmitted } = useFormState({ control });
  const fieldError = errors[name]?.message as string | undefined;
  const isTouched = touchedFields[name];
  const showError = showErrorOnTouched ? (isTouched || isSubmitted) && !!fieldError : !!fieldError;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <ProductSelector
          value={field.value}
          onChange={field.onChange}
          isRequired={isRequired}
          isInvalid={showError}
          errorMessage={showError ? fieldError : undefined}
          showAllOption={showAllOption}
          showEmptyOption={showEmptyOption}
          {...rest}
        />
      )}
    />
  );
};

FormProductSelector.displayName = 'FormProductSelector';

export default FormProductSelector;
